
<div class="modal-dialog confirm-dialog">
  <div class="modal-content" style="min-width:440px;">
    <form #orderForm="ngForm">
      <div class="modal-header">
        <h4 class="modal-title">Add time to all active completion estimates</h4>
        <button class="close" type="button" (click)="cancel()">&times;</button>
      </div>
      <div class="modal-body">
        <div class="row">
          <div class="form-group col-lg-6">
            <label for="increment">Increment:</label>
            <input class="form-control" id="increment" type="number" [(ngModel)]="increment" min="0" name="increment">
          </div>
          <div class="form-group col-lg-6">
            <label for="units">Units:</label>
            <select class="form-control" id="units" [(ngModel)]="units" name="units">
              <option value="days">Days</option>
              <option value="weeks">Weeks</option>
              <option value="months">Months</option>
            </select>
          </div>
        </div>
      </div>
      <div class="modal-footer"><span class="font-italic" *ngIf="message">
          <p class="text-left">{{ message }}</p></span>
        <button class="btn btn-primary" type="submit" (click)="finish()">Add Time</button>
        <button class="btn btn-outline-secondary" type="button" (click)="cancel()">Cancel</button>
      </div>
    </form>
  </div>
</div>